import { css } from '@emotion/react';

import { TYPOGRAPHY2 } from '../Styles';

export type FormFieldsRequirementVariant = 'all' | 'optional';

const FORM_FIELDS_REQUIREMENT_NOTE_STYLE = css`
  label: FORM_FIELDS_REQUIREMENT_NOTE_STYLE;
  ${TYPOGRAPHY2.xSmall}
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const FORM_FIELDS_REQUIREMENT_NOTE_INLINE_STYLE = css`
  label: FORM_FIELDS_REQUIREMENT_NOTE_INLINE_STYLE;
  text-transform: none;
  letter-spacing: normal;
  font-weight: normal;
`;

const VARIANT_COPY: Record<FormFieldsRequirementVariant, string> = {
  all: 'All fields are required',
  optional: '',
};

export const FormFieldsRequirementNote = ({
  variant = 'all',
  inline = false,
}: {
  variant?: FormFieldsRequirementVariant;
  inline?: boolean;
}) => {
  const copy = VARIANT_COPY[variant];
  if (!copy) return null;
  return (
    <span css={[FORM_FIELDS_REQUIREMENT_NOTE_STYLE, inline && FORM_FIELDS_REQUIREMENT_NOTE_INLINE_STYLE]}>
      {inline ? `(${copy})` : copy}
    </span>
  );
};
